import React from 'react';
import ReactDOM from 'react-dom';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import store from 'store';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

export default class RegResponseModal extends React.Component {
  constructor(props) {
    super(props);
    this.page = props.match.params.id;
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      user: ''
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => this.checkSubscription(), 1000);
    const thisNode = ReactDOM.findDOMNode(this);
    thisNode.querySelector('.back').focus();
  }

  componentWillMount() {
    const user = store.get('auth__user');
    this.setState({
      user
    })
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleClick() {
    let id = this.state.user.id ? this.state.user.id : this.state.user;
    //  bdReq.get(`/users/${id}/subscriptions`)
    bdReq.get(`/v2/account`)
      .then((response) => {
        if (response.status != 200) {
          store.remove('subscription');
          store.set('subscription', "no");
          this.props.history.push('/Freemium');
        }
        else {
          store.remove('subscription');
          store.set('subscription', "yes");
          store.remove('description');
          store.set('description', response.body.plan.description);
          this.props.history.push('/Home');
        }
      })
  }

  checkSubscription() {
    let id = this.state.user.id ? this.state.user.id : this.state.user;
    // bdReq.get(`/users/${id}/subscriptions`)
    bdReq.get(`/v2/account`)
      .then((response) => {
        if (response.status != 200) {
          store.remove('subscription');
          store.set('subscription', "no");
        }
        else {
          store.remove('subscription');
          store.set('subscription', "yes");
          store.remove('description');
          store.set('description', response.body.plan.description);
          this.props.history.push('/Home');
        }
      })
  }

  render() {
    return (
      <div className="reg-response-modal">
        <div className="model">
          <div className="row">
            <div className="col-12">
              {
                this.page == 0 ?
                  <h3 className="h--spacing-sm" style={{ marginTop: "2%" }}>
                    Check your email
                  </h3>
                  :
                  <h3 className="h--spacing-sm" style={{ marginTop: "2%" }}>
                    Subscription required
                  </h3>
              }
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {
                this.page == 0 ?
                  <h5 className="h--normalize-weight txt">
                    Set Password & Purchase the streaming subscription by clicking on the link
                    <br />we sent to your email or purchase a subscription within the Blackdove
                    <br />mobile app to access over 2000 pieces of the world's finest digital art
                    <br />for just $5 per month. The first month is free!
                  </h5>
                  :
                  <h5 className="h--normalize-weight txt">
                    This content is only available via our subscription services. You
                    <br />can purchase a subscription within the mobile app or by
                    <br />visiting www.blackdove.com
                  </h5>
              }
            </div>
          </div>
          <div className="row">
            <div className="col-2">
            </div>
            <div className="col-8">
              <div tabIndex="1" ref="back"
                className="back btn btn--round btn--dark"
                style={{ padding: '0.7em 1.8em', fontSize: '1.1em' }}
                onKeyDown={(e) => {
                  if (e.which == 13)
                    this.handleClick();
                }}
              ><span className="ion-chevron-left arrowBack"> </span> Back</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}